import { forwardRef, SetStateAction, useState } from "react";
import clsx from 'clsx';
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import { Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import "./save-solution.css";
import _ from "lodash";
import { subscribe } from "../../services/subscription";
import { sendSolutionEmail } from "../../services/email-service";

export default function SaveSolutionComponent({question, list1, list2, list3, list4, suggestion}:any): JSX.Element {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openSucess, setOpenSuccess] = useState(false);
  const handleOpenSuccess = () => {
    setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false);
      }, 1500);
  };
  const handleCloseSuccess = () => setOpenSuccess(false);

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailChecked, setEmailChecked] = useState(false);
  const [newsletterChecked, setNewsletterChecked] = useState(false);

  const handleFirstNameChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setLastName(event.target.value);
  };

  const handleEmailChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setEmail(event.target.value);
  };

  const handleEmailCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailChecked(event.target.checked);
  };

  const handleNewsletterCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewsletterChecked(event.target.checked);
  };

  /* send solution email START */
  let product1:any = null;
  let product2:any = null;
  let product3:any = null;
  let product4:any = null;
  if (list1.length > 0) {
    product1 = list1[0];
  }
  if (list2.length > 0) {
    product2 = list2[0]
  }
  if (list3.length > 0) {
    product3 = list3[0]
  }
  if (list4.length > 0) {
    product4 = list4[0]
  }
  const handleSend = () => {
    if (!_.isEmpty(firstName) && !_.isEmpty(lastName) && !_.isEmpty(email) && emailChecked && newsletterChecked) {
      let customerName = firstName + " " + lastName;
      sendSolutionEmail(email, customerName, question, product1, product2, product3, product4, suggestion);
      subscribe(email, firstName, lastName).then(() => {
        handleOpenSuccess();
        handleClose();
      } );
    }
  }
  /* send solution email END */

  return (
    <div>
      <button className="btn btn-new-search" onClick={handleOpen}>
        Save This Solution
      </button>
      <Modal className="save-solution-dialog"
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={{ width: 400 }}>
          <FormControl>
            <div className="input-field">
              <label>First Name *</label>
              <input type="text" value={firstName} onChange={handleFirstNameChange} />
            </div>
            <div className="input-field">
              <label>Last Name *</label>
              <input type="text" value={lastName} onChange={handleLastNameChange} />
            </div>
            <div className="input-field">
              <label>Email *</label>
              <input type="text" value={email} onChange={handleEmailChange} />
            </div>
            <FormControlLabel className="checkbox-field" control={<Checkbox checked={emailChecked} onChange={handleEmailCheckboxChange} />} label="I agree to receive a copy of the solution via email *" />
            <FormControlLabel className="checkbox-field" required control={<Checkbox checked={newsletterChecked} onChange={handleNewsletterCheckboxChange} />} label="I agree to subscribe to the newsletter" />
            <div className="remark">
              * are mandatory fields
            </div>
            <div className="actions">
              <button className="btn btn-secondary" onClick={handleSend}>Send me the email</button>
            </div>
          </FormControl>
        </ModalContent>
      </Modal>

      <Modal className="success-dialog"
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={openSucess}
        onClose={handleCloseSuccess}
        slots={{ backdrop: StyledBackdrop }}
      >
        <SuccessModalContent sx={{ width: 191 }}>
          <div className="modal-content">
            <div className="icon"><img src="/assets/icon-rocket.svg"/></div>
            <span className="text">The solution email has been sent!</span>
          </div>
        </SuccessModalContent>
      </Modal>
    </div>
  )
}

const Backdrop = forwardRef<
  HTMLDivElement,
  { open?: boolean; className: string }
>((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ 'base-Backdrop-open': open }, className)}
      ref={ref}
      {...other}
    />
  );
});

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const ModalContent = styled('div')(
  ({ theme }) => css`
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: #d8f397;
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    padding: 29px;
    color: #01402f;

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
      margin-bottom: 4px;
    }
  `,
);

const SuccessModalContent = styled('div')(
  ({ theme }) => css`
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: #b1b1e5;
    border-radius: 8px;
    padding: 20px;
    color: #01402f;
    border-shadow: 0px 0px 10px rgba(0,0,0,0.1);

    & .modal-content {
      text-align: center;
    }

    & .icon {
      margin-bottom: 6px;
    }

    & .text {
      color: #ffffff;
      font-size: 18px;
    }
  `,
);